export const COMPARISON_HERO_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'comparison-hero-layout',
  PLATFORM_VS_LABEL: 'vs',
  TOPFAN_BADGE_LABEL: 'TOPFAN',
  PLACEHOLDER_HEADING: 'Enter heading',
  DEFAULT_SUBHEADING:
    'A creator-first platform helping creators grow, engage, and earn through exclusive content, memberships, live experiences, and community interactions in one ecosystem.',
  DEFAULT_ALT_BACKGROUND_IMAGE: 'Hero background',
  DEFAULT_ALT_COMPETITOR_LOGO: 'Competitor logo',
  DEFAULT_ALT_TOPFAN_LOGO: 'TopFan logo'
} as const;
